/**
 * at() polyfill — 修复 marked@17 / react-markdown@10 在老浏览器中的兼容问题
 *
 * 背景：
 *   marked@17 在源码中大量使用 Array.prototype.at() / String.prototype.at() (ES2022)。
 *   这两个方法在以下环境不可用：
 *     - iOS Safari < 15.4
 *     - Chrome / Chromium < 92
 *     - 较老的 Android System WebView
 *     - 部分低端机型的内置浏览器
 *   当 marked 解析 Markdown 时若遇到这些环境，会抛出：
 *     "t.at is not a function" 并提示上报到 https://github.com/markedjs/marked
 *
 * 使用：
 *   必须在 import 'marked' / 'react-markdown' 之前 import 本文件。
 *   建议在 src/index.js 顶部最先 import。
 *
 * 实现说明：
 *   用 defineProperty 定义，且 writable/configurable 均为 true，
 *   仅在原生方法不存在时挂载，避免在现代浏览器中污染原型链。
 */
/* eslint-disable no-extend-native, func-names */

function atImpl(target, index) {
    const len = Number(target.length);
    if (Number.isNaN(len) || len === 0) return undefined;
    let i = Number(index);
    if (i < 0) i = Math.max(len + i, 0);
    else i = Math.min(i, len - 1);
    return target[i];
}

if (!Array.prototype.at) {
    Object.defineProperty(Array.prototype, 'at', {
        value: function at(index) {
            return atImpl(this, index);
        },
        writable: true,
        configurable: true,
    });
}

if (!String.prototype.at) {
    Object.defineProperty(String.prototype, 'at', {
        value: function at(index) {
            return atImpl(this, index);
        },
        writable: true,
        configurable: true,
    });
}

export {};
